import c from "classnames";
import { ComponentProps } from "react";

import { Box } from "@design-system/Box/Box";
import { Icon } from "@design-system/Icon/Icon";
import { Text } from "@design-system/Text/Text";

import classes from "./TileButton.module.css";

type Props = {
  title?: string;
  description?: string;
  icon?: ComponentProps<typeof Icon>["icon"];
  stretch?: boolean;
  onClick?: () => void;
};

export const TileButton = ({
  title,
  description,
  icon,
  stretch = false,
  onClick,
}: Props) => {
  return (
    <button
      className={c(classes.tileButton, stretch && classes.stretch)}
      type="button"
      onClick={onClick}
    >
      <Box direction="column" gap={8}>
        {icon && <Icon size="lg" icon={icon} />}
        <Box direction="column" gap={4}>
          {title && <Text size={14}>{title}</Text>}
          {description && (
            <Text size={12} color="textSecondary">
              {description}
            </Text>
          )}
        </Box>
      </Box>
    </button>
  );
};
